module.exports = __webpack_public_path__ + "static/media/lykke06.6c55d85c.jpg";